import {
  FETCH_LOT_DETAILS_SUCCESS,
  FETCH_BASIC_LOT_DETAILS_SUCCESS,
  FETCH_LOT_DETAILS_ERROR,
  FETCH_BASIC_LOT_DETAILS_ERROR,
  GET_LOT_DETAILS,
  GET_BASIC_LOT_DETAILS,
  SET_LOT_DETAILS,
  CLEAR_LOT,
  NOT_ME,
  NOT_ME_SUCCESS,
  NOT_ME_ERROR
} from "../actions/lot";
import {
  SET_VERIFIED
} from "../actions/ui";

import {
  setInfoHelpPage,
  CALL_ME,
  CALL_ME_SUCCESS,
  CALL_ME_ERROR
} from "../actions/infoHelp";
import { GET_GEOSUGGEST_ADDRESS } from "../actions/address";

import { SET_PICKUP_FORM } from "../actions/pickupForm";
import { SET_PICKUP_ADDRESS } from "../actions/address";
import defaultLogo from "../../logo.svg";

import {
  lotDetailsServicePath,
  basicLotDetailsServicePath,
  notMeServicePath,
  callMeServicePath,
  MAX_ALLOWED_PICKUP_DAY
} from "../../config";
import { apiRequest } from "../actions/api";

import { processFields } from "form-metadata-2";
import lotDetailsMapper from "../../serviceMappers/lot";
import { goToView } from "../actions/ui";
import locale from "../../utils/locale";
import { showNotification } from "../actions/notification";

// this middleware only cares about the geting lot details action
export const getLotDetails = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === GET_LOT_DETAILS) {
    const uuid = action.payload.id;
    const postCode = action.payload.postCode;
    const vrn = action.payload.vrn;

    dispatch(
      apiRequest(
        "GET",
        lotDetailsServicePath(uuid, postCode, vrn),
        null,
        FETCH_LOT_DETAILS_SUCCESS,
        FETCH_LOT_DETAILS_ERROR
      )
    );
    dispatch({ type: SET_LOT_DETAILS, payload: { uuid } });
  }
};

export const getBasicLotDetails = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === GET_BASIC_LOT_DETAILS) {
    const uuid = action.payload.id;

    dispatch(
      apiRequest(
        "GET",
        basicLotDetailsServicePath(uuid),
        null,
        FETCH_BASIC_LOT_DETAILS_SUCCESS,
        FETCH_BASIC_LOT_DETAILS_ERROR
      )
    );
    dispatch({ type: SET_LOT_DETAILS, payload: { uuid } });
  }
};

export const processBasicLotDetails = ({ dispatch }) => next => action => {
  next(action);

  if (action.type === FETCH_BASIC_LOT_DETAILS_SUCCESS) {
    let yardPhoneNumber = action.payload.yard_phone_number
      ? action.payload.yard_phone_number
      : "";
    let text_message = action.payload.text_message
      ? action.payload.text_message : "";
    let verificationPageMessage = action.payload.verification_message
      ? action.payload.verification_message
      : "";
    let logo = action.payload.seller_logo
      ? action.payload.seller_logo
      : defaultLogo;
    let sellerType = action.payload.seller_type
    let isSellerLogoOn = action.payload.seller_logo ? true : false;
    let totalSteps = action.payload.seller_logo == 'C' ? 4 : 4 
    dispatch({ type: SET_LOT_DETAILS, payload: { yardPhoneNumber, verificationPageMessage, text_message, logo, isSellerLogoOn, sellerType, totalSteps} });
  }
}

// on successful fetch, process the lot details data
export const processLotDetails = ({ dispatch }) => next => action => {
  next(action);

  if (action.type === FETCH_LOT_DETAILS_SUCCESS && action.payload.messageType != "error") {
    const processedFields = processFields(
      action.payload.data,
      lotDetailsMapper
    );
    let pickupFormState = processedFields;
    let alreadySubmitted = false;
    let yardPhoneNumber = action.payload.yard_phone_number
      ? action.payload.yard_phone_number
      : "";
    if (processedFields.fields.isSubmitted) {
      if (processedFields.fields.isSubmitted.value) {
        pickupFormState = {
          ...processedFields,
          formSubmitted: true,
          statusMessage: processedFields.fields.statusMessage.value
        };
        alreadySubmitted = true;
      }
    }
    dispatch({ type: SET_VERIFIED });

    dispatch({
      type: SET_LOT_DETAILS,
      payload: {
        ...getLotDetailsFromFields(processedFields.fields),
        yardPhoneNumber: yardPhoneNumber
      }
    });
    dispatch({ type: SET_PICKUP_FORM, payload: pickupFormState });

    //if already submitted no need to set address
    if (!alreadySubmitted) {
      dispatch({
        type: SET_PICKUP_ADDRESS,
        payload: getAddressFromFields(processedFields.fields)
      });
      dispatch({ type: GET_GEOSUGGEST_ADDRESS });
    }
  }
};

const getAddressFromFields = fields => {
  return {
    addressLine1: fields["addressLine1"] ? fields["addressLine1"].value : "",
    addressLine2: fields["addressLine2"] ? fields["addressLine2"].value : "",
    city: fields["city"] ? fields["city"].value : "",
    state: fields["state"] ? fields["state"].value : "",
    zip: fields["zip"] ? fields["zip"].value : ""
  };
};

const getLotDetailsFromFields = fields => {
  return {
    year: fields["vehicleYear"] ? fields["vehicleYear"].value : "",
    color: fields["vehicleColor"] ? fields["vehicleColor"].value : "",
    make: fields["vehicleMake"] ? fields["vehicleMake"].value : "",
    model: fields["vehicleModel"] ? fields["vehicleModel"].value : "",
    referenceNumber: fields["lotNumber"] ? fields["lotNumber"].value : "",
    yardPhoneNumber: fields["yardPhoneNumber"]
      ? fields["yardPhoneNumber"].value
      : "",
    maxAllowedPickupDays: fields["maxAllowedPickupDays"].value
      ? fields["maxAllowedPickupDays"].value
      : MAX_ALLOWED_PICKUP_DAY,
    holidays: fields["holidays"].value ? fields["holidays"].value : []
  };
};

export const handleNotMe = ({ dispatch, getState }) => next => action => {
  next(action);
  let uuid = getState().lot.uuid;

  if (action.type === NOT_ME) {
    dispatch(
      apiRequest(
        "PUT",
        notMeServicePath(uuid),
        {},
        NOT_ME_SUCCESS,
        NOT_ME_ERROR
      )
    );
  }

  if (action.type === NOT_ME_SUCCESS) {
    let message = action.payload.message
      ? action.payload.message
      : locale("callMeSuccess");
    dispatch(setInfoHelpPage(message));
    dispatch(goToView("InfoHelpView"));
    dispatch({ type: CLEAR_LOT });
  }
};

export const handleCallMe = ({ dispatch, getState }) => next => action => {
  next(action);
  let uuid = getState().lot.uuid;
  if (action.type === CALL_ME) {
    dispatch(
      apiRequest(
        "PUT",
        callMeServicePath(uuid),
        {},
        CALL_ME_SUCCESS,
        CALL_ME_ERROR
      )
    );
  }

  if (action.type === CALL_ME_SUCCESS) {
    let message = action.payload.message
      ? action.payload.message
      : locale("callMeSuccess");
    dispatch(
      setInfoHelpPage(
        locale("callMeMessage", getState().lot.yardPhoneNumber),
        message,
        false
      )
    );
  }
};
export const lotsMdl = [
  getLotDetails,
  getBasicLotDetails,
  processLotDetails,
  processBasicLotDetails,
  handleNotMe,
  handleCallMe
];



// WEBPACK FOOTER //
// ./src/redux/middleware/lot.js